<template>
  <div class="chat-list">
    <div class="p-3 border-bottom">
      <h5 class="mb-0">Чаты</h5>
    </div>
    <BListGroup flush>
      <BListGroupItem
        v-for="chat in chats"
        :key="chat.id"
        :active="chat.id === selectedChatId"
        @click="$emit('select-chat', chat.id)"
        class="chat-item"
      >
        <div class="d-flex align-items-center">
          <BAvatar variant="primary" :text="getInitials(chat.name)" class="me-3"></BAvatar>
          <div class="flex-grow-1">
            <div class="d-flex justify-content-between align-items-start">
              <strong class="chat-name">{{ chat.name }}</strong>
              <small class="text-muted">{{ formatTime(chat.lastMessageTime) }}</small>
            </div>
            <p class="mb-0 text-muted chat-last-message">{{ chat.lastMessage }}</p>
          </div>
          <BBadge v-if="chat.unreadCount > 0" variant="primary" pill>
            {{ chat.unreadCount }}
          </BBadge>
        </div>
      </BListGroupItem>
    </BListGroup>
  </div>
</template>

<script>
//import { computed } from 'vue'
import {
  BListGroup,
  BListGroupItem,
  BAvatar,
  BBadge
} from 'bootstrap-vue-next'

export default {
  name: 'ChatList',
  components: {
    BListGroup,
    BListGroupItem,
    BAvatar,
    BBadge,
  },
  props: {
    chats: {
      type: Array,
      required: true
    },
    currentUser: {
      type: Object,
      required: true
    },
    selectedChatId: {
      type: Number,
      default: null
    }
  },
  emits: ['select-chat'],
  setup() {
    const getInitials = (name) => {
      return name
        .split(' ')
        .map(word => word[0])
        .join('')
        .toUpperCase()
    }

    const formatTime = (timestamp) => {
      if (!timestamp) return ''

      return new Date(timestamp * 1000).toLocaleTimeString('ru-RU', {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: '2-digit',
        minute: '2-digit'
      })
    }

    return {
      getInitials,
      formatTime
    }
  }
}
</script>

<style scoped>
.chat-item {
  cursor: pointer;
  border: none !important;
}

.chat-item:hover {
  background-color: #e9ecef;
}
.chat-item:hover .chat-name {
  color: black;
}

.chat-item > div {
  grid-gap: 10px;
}

.chat-name {
  font-size: 0.9rem;
}

.chat-last-message {
  font-size: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
}
</style>
